<template>
    <el-table
        :data="hostnames"
        style="width: 100%">
        <el-table-column
            prop="fqdn"
            label="Domain">
        </el-table-column>
        <el-table-column
            label="Status">
            <template slot-scope="scope">
                {{scope.row.deleted_at == null ? 'Active' : 'Inactive'}}
            </template>
        </el-table-column>
        <el-table-column
            label="Default">
            <template slot-scope="scope">
                {{ scope.row.id == defaultId ? 'Default' : '' }}
            </template>
        </el-table-column>
        <el-table-column
            fixed="right"
            label="Actions"
            width="120">
            <template slot-scope="scope">
                <el-button type="info" round>Edit</el-button>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
export default {
  name: 'HostsTable',
  components: {
  },
  props: {
      defaultId: {
          default: null
      },
      hostnames: {
          required: true
      }
  },
  data() {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  mounted() {
  },
  updated() {
  },
  activated() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
// @import '@assets/sass/backend/_core-variables.scss';
</style>
